<template>
  <div class='panic-buy-box'>
    <div class='slide-toggle' @click="slideToggle()">
      <div class="title">即将抢购时间</div>
      <div class="detail-allow-right" :class="[flashSaleOpen ? 'rotate-45' : '']"></div>
    </div>
    <div
      v-if="nodeList"
      :class="{'flashsale-time-list': true, 'slide-out': flashSaleOpen}">
        <div class="time-item" v-for="(item, i) in nodeList" :key="i">{{item.GapDay === 1 ? '次日' : ''}}{{item.Node}}</div>
    </div>
    <div v-else class="list-cell-none">抱歉，该商品今天暂无补货计划，明天再来吧~</div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      flashSaleOpen: false
    }
  },
  props: {
    nodeList: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    slideToggle () {
      this.flashSaleOpen = !this.flashSaleOpen
    }
  }
}
</script>

<style scoped>
  .panic-buy-box{
    margin-top: 3%;
    background: #ffffff;
  }
  .slide-toggle {
    position: relative;
    display: flex;
    justify-content: space-between;
    padding:3% 4%;
    box-sizing: border-box;
    transition: 0.3s;
    border-bottom: 1px solid #f2f2f2;
  }
  .slide-toggle .title{
    font-size: 15px;
  }
  .detail-allow-right{
    border: 2px solid #c8c8cd;
    border-bottom-width: 0;
    border-left-width: 0;
    content: " ";
    top: 50%;
    right: 20px;
    position: absolute;
    width: 5px;
    height: 5px;
    transform: translateY(-50%) rotate(135deg);
  }
  .rotate-45 {
    transform: rotate(-45deg);
    transition: 0.4s linear 0s;
  }
  /* node list */
  .flashsale-time-list{
    display: flex;
    justify-items: center;
    flex-wrap: wrap;
    padding: 10px 15px 0 15px;
    transition: all 0.2s ease-in;
    box-sizing: border-box;
    overflow: hidden;
    height: 47px;
  }
  .flashsale-time-list.slide-out{
    height: auto;
  }
  .flashsale-time-list .time-item{
    background: #F0F0F0;
    height: 25px;
    line-height: 25px;
    padding: 0 8px;
    box-sizing: border-box;
    margin-bottom: 12px;
    margin-right: 10px;
    color: #aaa;
    border-radius: 3px;
  }
  .list-cell-none{
    height: 45px;
    line-height: 45px;
    text-align: center;
    color: #999;
    font-size: 14px;
  }
</style>
